document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('mobileDrawer');
    const openBtn = document.querySelector('.custom-header__hamburger');
    const closeBtn = document.querySelector('.custom-menu__drawer--close');
    const overlay = document.querySelector('.custom-menu__drawer--mobile__overlay');

    if (openBtn) {
        openBtn.addEventListener('click', () => {
            drawer.classList.add('active');
        });
    }
    if(closeBtn) {
        closeBtn.addEventListener('click', () => {
            drawer.classList.remove('active');
        });
    }
    if(overlay) {
        overlay.addEventListener('click', () => {
            drawer.classList.remove('active');
        }); 
    }
    document.querySelectorAll('.custom-menu__drawer--submenu--toggle').forEach(btn => {
        if(btn) {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                btn.classList.toggle('active');
                const submenu = btn.closest('li').querySelector('.custom-menu__drawer--submenu');
                    submenu.classList.toggle('active');
            });
        }
    });
});